<template>
  <div class="page-content almacen-page">
    <div class="almacen-wrapper">
      <div class="almacen-card">
        <!-- Header -->
        <div class="almacen-header">
          <div>
            <p class="almacen-title">Unidades y seriales</p>
            <p class="almacen-subtitle">
              Gestión de unidades físicas y sus identificadores.
            </p>
          </div>

          <div class="almacen-header-actions">
            <button
              type="button"
              class="ios-primary-button"
              @click="mostrarFormulario = true"
            >
              + Agregar unidades
            </button>
          </div>
        </div>

        <!-- Contenedor de lista -->
        <div class="almacen-list-container">
          <div v-if="cargando" class="almacen-loading">
            Cargando unidades…
          </div>

          <div
            v-else-if="!unidades.length"
            class="almacen-empty"
          >
            No hay unidades registradas todavía.
          </div>

          <div v-else class="almacen-table-wrapper">
            <TablaUnidades :unidades="unidades" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal formulario de unidades -->
    <FormularioUnidades
      v-if="mostrarFormulario"
      :productos="productos"
      @cerrar="mostrarFormulario = false"
      @guardado="handleGuardado"
    />
  </div>
</template>
<script>
import axios from 'axios';
import TablaUnidades from '@/components/almacen/unidades/TablaUnidades.vue';
import FormularioUnidades from '@/components/almacen/unidades/FormularioUnidades.vue';

export default {
  name: 'DashboardUnidades',
  components: {
    TablaUnidades,
    FormularioUnidades,
  },
  data() {
    return {
      // Podemos dejar productos por compatibilidad,
      // pero ya no se cargan aquí.
      productos: [],
      unidades: [],
      mostrarFormulario: false,
      cargando: false,
    };
  },
  mounted() {
    this.recargar();
  },
  methods: {
    async recargar() {
      this.cargando = true;
      try {
        const resUni = await axios.get('/api/almacen/unidades/listar');
        this.unidades = Array.isArray(resUni.data) ? resUni.data : [];
      } catch (err) {
        console.error('Error al cargar unidades:', err);
        this.$toast?.error('No se pudieron cargar las unidades.');
      } finally {
        this.cargando = false;
      }
    },
    handleGuardado() {
      // Cerrar modal y recargar lista de unidades
      this.mostrarFormulario = false;
      this.recargar();
    },
  },
};
</script>


<style scoped>
.almacen-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.almacen-wrapper {
  width: 100%;
  max-width: 960px;
}

.almacen-card {
  border-radius: 1.8rem;
  padding: 1.5rem 1.4rem 1.2rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.96)
    );
  backdrop-filter: blur(24px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.9),
    0 0 0 1px rgba(15, 23, 42, 0.85);
}

.almacen-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.1rem;
}

.almacen-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #e5e7eb;
}

.almacen-subtitle {
  font-size: 0.8rem;
  color: #94a3b8;
}

.almacen-header-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.almacen-list-container {
  border-radius: 1.25rem;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(15, 23, 42, 0.92);
  padding: 0.7rem 0.7rem 0.6rem;
  min-height: 160px;
}

.almacen-table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.almacen-loading,
.almacen-empty {
  font-size: 0.85rem;
  color: #e5e7eb;
  padding: 0.4rem 0.25rem;
}

/* Scroll de la tabla, fino y acorde al glass */
.almacen-table-wrapper::-webkit-scrollbar {
  height: 6px;
}
.almacen-table-wrapper::-webkit-scrollbar-track {
  background: transparent;
}
.almacen-table-wrapper::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.55);
  border-radius: 999px;
}

/* Responsive */
@media (max-width: 768px) {
  .almacen-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .almacen-header-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
